/* eslint-disable no-var */
/* eslint-disable react-refresh/only-export-components */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React from 'react';
import AppContexto from './AppContexto';

const AppContext = React.createContext<AppContexto|null>(null);
const appContexto = new AppContexto()

declare global {
  var _APPCONTEXTO: AppContexto | null;
}

export function AppContextoReact({ children } : any)
{

    if (typeof window !== "undefined")
    {
        window._APPCONTEXTO = appContexto
    }
    
    return (
        <AppContext.Provider value={appContexto}>
            {children}
        </AppContext.Provider>
    );
}

export function useAppContextoReact()
{
    return React.useContext(AppContext);
}